export default {
  addNew: 'Create Order',
  labRequestHeader: 'Order Entry',
  labRequest: 'Order Entry',
  lablaboratoryName: 'Laboratory',
  dateCreated: 'Requested Date',
  patientName: 'Patient Name',
  patientId: 'Patient ID',
  patientFullname: 'Patient Name',
  status: 'Status',
  mainMenu: 'Back to Main Menu',
  addEditHeader1: 'Patient Information (Please fill in all required fields for the benefit of the patient)',
  addEditHeader2: '(Please complete all required information',
  addEditHeader3: 'for the patient’s benefit)',
  patientEditButton: 'Edit Patient Information',
  saveEditPatientbutton: 'Save Patient Information',
  HN: 'HN',
  prefix: 'Prefix',
  prefixRequire: 'Prefix*',
  firstName: 'First Name',
  middleName: 'Middle Name',
  lastName: 'Last Name',
  brithDay: 'Birth Date',
  brithDayRequire: 'Birth Date*',
  age: 'Age',
  receiveData: 'Collection Date',
  requestBy: 'Physician',
  sex: 'Gender',
  sexRequire: 'Gender*',
  brithdayOrAge: 'Birth Date or Age',
  orderitemHeader: 'Test Order List',
  lablaboratory: 'Laboratory Department',
  search: 'Search',
  orderItem: 'Test Order List',
  orderItemSelected: 'Selected Orders',
  save: 'Save',
  close: 'Close',
  cancel: 'Cancel',
  statusObj: {
    OP: 'Requested',
    COLLECTION: 'Collection',
    RECEIVEDALL: 'Received',
    FIRSTAPPROVE: 'Reported',
    LASTAPPROVE: 'Approved',
    CA: 'Cancelled',
    labApprove: 'Released',
    labNotApprove: 'Pending'
  },
  labNumber: 'Lab No.',
  turnaroundTime: 'TAT',
  saveCreateLabOreder: 'Submit Order',
  remark: 'Remark',
  remarkForm: 'Form',
  packageNo: 'Package No.',
  sendDate: 'Send Date',
  errorNolab: 'Please create a lab order first',
  collectDate: 'Collection Date',
  viewItem: 'Order Details',
  viewOrderId: 'Order ID',
  viewOrderDesc: 'Order Description',
  cancelPackage: 'Cancel Package',
  sendPackage: 'Send Package',
  payment: 'Payment Type',
  hln: 'Hospital Lab No.',
  paymentStatus: 'Payment Status',
  paymentType: 'Payment Type',
  cancelLab: 'Cancel Lab',
  paymentPage: 'Payment',
  orderID: 'Test Item ID',
  orderName: 'Test Item Name',
  labStatus: 'Lab Status',
  labApproveStatus: 'Report Status',
  refDoc: 'Reference Document',
  serviceChannel: 'Service Channel',
  price: 'Price (Baht)',
  specimenType: 'Specimen Type',
  selectProbes: 'Select Probes',
  diagnosis: 'Diagnosis',
  diagnosisDesc: 'Disease / Diagnosis',
  errorPrice: 'Please contact staff to confirm the price — this test is outside the valid pricing period',
  isGetBack: 'Request Sample Return',
  releasedDate: 'Sent Date',
  receivedDate: 'Received Date',
  isUrgent: 'Urgent Result Requested',
  reportedDate: 'Reported Date',
  volumnUrine: 'Urine Volume',
  addOrderItem: 'Add Order Item',
  deleteOrderItem: 'Delete Order Item',
  specimenID: 'Specimen ID',
  requireCollectDateError: 'Cannot close window — some items still require specimen collection date update',
  editCollectionDate: 'Edit Specimen Collection Date',
  requestReport: 'Request Form',
  packageReport: 'Package Form',
  clearData: 'Clear Data',
  searchData: 'Search Data',
  receiptCreate: 'Receipt Issued',
  receiptSent: 'Receipt Sent',
  note: 'Note',
  submit: 'Submit',
  searchPatient: 'Search Patient',
  add: 'Add',
  request: 'Lab Request',
  editPatientInfo: 'Edit Patient',
  patientInfo: 'Patient Infomation',
  searchName: 'Search by First Name',
  searchLastName: 'Search by Last Name',
  searchHN: 'Search by HN',
  totalPrice: 'Total Price',
  enterReceiveDate: 'Please specify specimen collection date',
  comment: 'Comment',
  saveSucess: 'Save order item successfully',
  cannotEditOldPatient: 'Cannot edit old patient information',
  confirmDeleteSelected: 'Delete selected lab order items?',
  errorDuplicateItem: 'Cannot select an item that already exists',
  createOrderSuccess: 'Create new lab order successfully',
  aOrderItem: 'Order Item',
  beforeAddOrderItem: ' completely before adding order items',
  prefixSexMismatch: 'and ensure prefix and gender match',
  pleaseFill: 'Please fill in',
  errorCreateOrderIncompleteData: 'Please fill in all required fields: First Name, Date of Birth, Gender, and Order Items',
  errorCreatePackageBeforeSend: 'Please create lab order before sending',
  printRequestError: 'Please send the lab order before printing the request form',
  confirmCloseWithoutSave: 'Do you want to exit the lab request page without saving?',
  pleaseSelectItemToSend: 'Please select items to send for testing',
  pleaseSelectItemToCancelSend: 'Please select items to cancel testing request',
  pleaseSelectItemToCancel: 'Please select items to cancel',
  pleaseSelectItemToPrint: 'Please select items to print the request form',
  pleaseSelectItemToPrintPackage: 'Please select items to print the package form',
  confirmSendRequest: 'Do you want to create a test package?',
  confirmCancelSendRequest: 'Do you want to cancel the test request?',
  sendRequestSuccess: 'Test request sent successfully. Please proceed to payment.',
  confirmCancelLabRequest: 'Do you want to cancel the lab request?',
  confirmPrintRequest: 'Do you want to print the lab request form?',
  printPackageError: 'Please create the package before printing',
  confirmPrintPackage: 'Do you want to print the package form?',
  errorSendRequestDateSendNotNull: 'Orders that have already been sent for testing cannot be sent again. Please cancel the previous test request first.',
  errorCannotCancelSendRequestReceived: 'Cannot cancel the test request as the specimen has already been received.',
  errorCannotCancelSendRequest: 'Cannot cancel the test request.',
  cancelSendRequestSuccess: 'Test request cancellation successful.',
  errorCannotCancelNotSendRequest: 'Orders that have not yet been sent for testing cannot have their test requests cancelled.',
  errorCreatePackageBeforeCancel: 'Please create the lab order before cancelling the test request.',
  errorCannotCancelLabRequestPackageNotNull: 'Orders with existing packages cannot be cancelled.',
  errorCannotCancelLabRequestAlreadyCancelled: 'Cannot cancel an order that has already been cancelled.',
  createOrderFailed: 'Create order failed',
  errorFindPatient: 'Please search by First Name, Last Name, or HN',
  cannotCreateOrder: 'Cannot create order',
  editPatient: 'Edit Patient',
  editPatientFailed: 'Edit Patient Failed',
  errorPayment: 'No payment type found. Please contact staff to confirm the payment type',
  savePatientSuccess: 'Saved successfully',
  searchCustomerName: 'Search by Customer Name',
  customer: 'Customer',
  PleaseEnterCustomerName: 'Please enter a customer name before searching.',
  PleaseEnterPrefixFirstNameAndLastName: 'Please enter Prefix, First Name, and Last Name before proceeding.',
  patientRights: 'Patient Rights',
  cid: 'Identification Number',
  CustomerType: 'Customer Type',
  phoneNumber: 'Phone Number',
  TaxIDNumber: 'Tax ID Number',
  emailAddress: 'E-mail Address',
  CustomerName: 'Customer Name',
  address: 'Address',
  addressOptional: 'Address (Optional)',
  city: 'City',
  state: 'State/Province',
  country: 'Country',
  zip: 'Zip Code',
  holdCode: 'Hold Code',
  PayTerms: 'Pay Terms',
  qty: 'QTY',
  discPct: '% Discount',
  discAmount: 'Discount Amount',
  totalAmount: 'Total Amount',
  ReceiptForm: 'Receipt Form',
  SIDSticker: 'SID STICKER',
  No: 'No.',
  itemNo: 'Item No.',
  itemDesc: 'Item Description',
  containerType: 'Container Type',
  orderItemID: 'Order Item ID',
  orderItemName: 'Order Item Name',
  testItemID: 'Test Item ID',
  testItemName: 'Test Item Name',
  pricing: 'Pricing',
  MessageStatusOpenDeleteOrderItem: 'Status must have Open can Delete Order Item',
  MessageStatusOpenAddOrderItem: 'Status must have Open can Add Order Item',
  active: 'Active',
  newCustomer: 'New Customer',
  customerInformation: 'Customer Information',
  copyPatient: 'Copy Patient',
  Gender: 'Gender',
  CollectionDate: 'Collection Date',
  SecondaryApprovedDate: 'Result Approved Date',
  AiProcessing: 'AI Processing',
  Age: 'Age',
  LabReport: 'Lab Report',
  AIGeneratedLabReport: 'AI-Generated Lab Report',
  LabResultReport: 'Lab Result Report',
  AiProcessingTitle: 'Submitted to AI!',
  AiProcessingText: 'The report has been successfully submitted for AI processing.'
}
